import React from "react"
import PropTypes from "prop-types"
import {Select, Tree} from "antd"

const Option = Select.Option;
const TreeNode = Tree.TreeNode;

export default class LovTransfer extends React.Component {

    static propTypes = {
        globalLovs: PropTypes.object.isRequired,
        mappings: PropTypes.array.isRequired,
        gettingMapping: PropTypes.bool.isRequired,
        selectedGlobalType: PropTypes.string,
        handleGlobalTypeChange: PropTypes.func.isRequired,
        handleGlobalLovChange: PropTypes.func.isRequired
    };

    render() {
        const {globalLovs, mappings, handleGlobalTypeChange, selectedGlobalType, handleGlobalLovChange} = this.props;
        const categories = Object.keys(globalLovs);
        const dataSource = globalLovs[selectedGlobalType] || [];
        const selectedGlobalLovs = mappings.filter(lov => lov.type === selectedGlobalType).map(lov => lov.code);

        return <div>
            <Select value={selectedGlobalType} style={{width: '100%', minWidth: 200}} placeholder="Test"
                    onChange={handleGlobalTypeChange}>
                {categories.map(c => <Option key={c} value={c}>{c}</Option>)}
            </Select>
            <div style={{maxHeight: 790, overflowY: 'auto'}} className="lov-card">
                <Tree multiple onSelect={handleGlobalLovChange} selectedKeys={selectedGlobalLovs}>
                    {dataSource.map(lov => <TreeNode key={lov.code} title={lov.label}/>)}
                </Tree>
            </div>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/js/lovs/map/LovTransfer.js